import { useState } from "react";
import { useTenantTranslation } from "hooks/formatters";
import { useFormatLocalDateString } from "./useFormatLocalDate";

export const useExcelName = () => {
  const { t } = useTenantTranslation();
  const format = useFormatLocalDateString("date");
  const [now] = useState(() => new Date());
  return `${t("plan")}-${format(now.toDateString())}.xlsx`
    .toLowerCase()
    .split("/")
    .join("");
};
